import { useEffect } from 'react';
import { Effect } from 'types/utils';

const useMount = (effect: Effect) => {
  // Run effect only on the mount, Hence disabling eslint
  useEffect(effect, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useMount;
